import { getFallbackAds } from './api'

export function getLocalizedAds(state) {
    let result
    try {
        result = state.locales[state.locale]
    } catch (error) {
        console.info(`Encountered error while setting localized ad items: ${error.message}`)
    }

    // return empty result
    if (result == null) {
        return {
            fetching: false,
            outdated: true,
            ads: getFallbackAds(state.isSteam, state.locale),
        }
    }

    return result
}

export function getLocalizedAdsForLocale(state, locale) {
    let result
    try {
        result = state.locales[locale]
    } catch (error) {
        console.info(`Encountered error while setting localized ad items: ${error.message}`)
    }

    // return empty result
    if (result == null) {
        return {
            fetching: false,
            outdated: true,
            ads: getFallbackAds(state.isSteam, locale),
        }
    }

    return result
}

export function getFetching(state) {
    return getLocalizedAds(state).fetching
}

export function getOutdated(state) {
    return getLocalizedAds(state).outdated
}

export function getAds(state) {
    return getLocalizedAds(state).ads
}

export function getSteam(state) {
    return state.isSteam
}

export function getLanguage(state) {
    return state.locale
}



// WEBPACK FOOTER //
// ./src/features/Ads/data/feed/selectors.js